module.exports = __webpack_public_path__ + "img/slider-bg-ipad.b28dc2bd.svg";